// @flow
import React, { type Node, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from 'app/common/layouts/RowLayout';
import type { Klass } from 'app/dataTypes/Klasses.types';

import useStudentFirstNameGenitive from './useStudentFirstNameGenitive';


type Props = {
  studentId: string,
  klass: Klass,
}

const JournalHeaderSummary = ({ studentId, klass }: Props): Node => {
  const { t } = useTranslation('dnevnik');
  const name = useStudentFirstNameGenitive(studentId);

  const header = useMemo(() => {
    const part1 = t('journal_header_part1', { name });
    const totalText = t('total', 'итоговые');
    const part2 = t('journal_header_part2', {
      currentPeriod: totalText,
      year: klass.schoolyearTitle,
      klass: klass.title,
    });
    return `${part1} ${part2}`;
  }, [name, t, klass.schoolyearTitle, klass.title]);

  return (
    <Header>{header}</Header>
  );
};

export default JournalHeaderSummary;
